import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface ErrorState {
  value: boolean;
  type?: string;
}

// Define the initial state using that type
const initialState: ErrorState = {
  value: false,
};

export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    removeError: (state) => {
      state.value = false;
      state.type = '';
    },
    addError: (state, action: PayloadAction<string>) => {
      state.value = true;
      state.type = action.payload;
    },
  },
});

export const { removeError, addError } = errorSlice.actions;

export default errorSlice.reducer;
